/**
 * @description Значение услуги.
 * @type {string}
 */
const SERVICE_VALUE = 'service';

/**
 * @description Значение категории.
 * @type {string}
 */
const CATEGORY_VALUE = 'service-category';

/**
 * @description Значение прайс-листов.
 * @type {string}
 */
const PRICE_LIST_VALUE = 'service-price-list';

/**
 * @description Примись формы добавления элементов услуг
 */
export default {
  computed: {
    /**
     * @description Выбрана категория.
     * @returns {boolean}
     */
    isSelectCategory() {
      return this.selectedType === CATEGORY_VALUE;
    },
    /**
     * @description Выбран прайс-лист.
     * @returns {boolean}
     */
    isSelectedPriceList() {
      return this.selectedType === PRICE_LIST_VALUE;
    },
    /**
     * @description Выбрана услуга.
     * @returns {boolean}
     */
    isSelectedService() {
      return this.selectedType === SERVICE_VALUE;
    },
  },
  data() {
    return {
      /**
       * @description Типы элемента
       * @type {Array}
       */
      itemTypes: [
        {
          title: 'Услуга',
          value: SERVICE_VALUE,
        },
        {
          title: 'Категория',
          value: CATEGORY_VALUE,
        },
        {
          title: 'Прайс-лист',
          value: PRICE_LIST_VALUE,
        },
      ],
      /**
       * @description Выбранный тип элемента
       * @type string
       */
      selectedType: SERVICE_VALUE,
    };
  },
};
